import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';

export const transactionDownloadReserve = http.post(
  createMockEndpoint('/transaction/download'),
  async () => {
    await delay(500);
    return HttpResponse.json(null, { status: 200 });
  },
);
